import { Box, Skeleton, Stack } from "@mui/material";
import { v4 as uuidv4 } from "uuid";

export default function PayItemsSkeleton() {
	return (
		<Stack direction={"column"}>
			<Stack direction={"row"} mb={3} justifyContent={"space-between"} alignItems={"center"}>
				<Skeleton variant="rectangular" width={250} height={30} className={"rounded-md"} />
				<Stack direction={"row"} spacing={4} alignItems={"center"}>
					<Skeleton variant="rectangular" width={125} height={30} className={"rounded-md"} />
					<Skeleton variant="rectangular" width={125} height={30} className={"rounded-md"} />
				</Stack>
			</Stack>
			{/* Columns Headers */}
			<Stack direction={"row"} columnGap={20} mb={2}>
				<Skeleton variant="text" width={150} height={30} className={"rounded-md"} />
				<Skeleton variant="text" width={150} height={30} className={"rounded-md"} />
			</Stack>
			<Box>
				{Array.from({ length: 7 }).map(() => {
					return (
						<Stack direction={"row"} spacing={20} mb={3} key={`skeleton-row-${uuidv4()}`}>
							<Stack direction={"row"} spacing={1} alignItems={"center"}>
								<Skeleton variant="rectangular" width={150} height={15} className={"rounded-md"} />
							</Stack>
							<Stack direction={"row"} spacing={1}>
								<Skeleton variant="rectangular" width={200} height={30} className={"rounded-md"} />
								<Skeleton variant="circular" width={30} height={30} />
							</Stack>
						</Stack>
					);
				})}
			</Box>
			{/*	Update Now Button*/}
			<Skeleton variant="text" width={100} height={40} className={"!rounded-2xl"} />
		</Stack>
	);
}
